export default __webpack_public_path__ + "static/comprehensive_cloud-a0930c8a6b2da480637a74a125d1cc94.webp";